import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { deepQuotes } from '../data/content';
export function Testimonials() {
  return <Section tone="white" eyebrow="Testimonianze" title="Storie reali di impatto" data-id="element-162" data-mp="3fznrfeogiyy7">
      <ul className="mx-auto max-w-narrow divide-y divide-gray-200" data-id="element-163" data-mp="3fxb2ghka7obn">
        {deepQuotes.map(quote => <li key={`${quote.author}-${quote.city}`} className="grid gap-4 py-8 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,14rem)_1fr] md:gap-10" data-id="element-164" data-mp="36yzeknasv4mw">
            <div className="flex items-start gap-3" data-id="element-165" data-mp="321zaghxigbyf">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-night font-display text-xs font-bold text-amber-400" data-id="element-166" data-mp="2x1urml94r551">
                {quote.initials}
              </span>
              <span data-id="element-167" data-mp="v8589t0m550o">
                <span className="flex gap-0.5" aria-label="5 stelle su 5" data-id="element-168" data-mp="v8nd3e1ccrk7">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-169" data-mp="h67xhyy0he7q" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-display font-extrabold tracking-tight text-night" data-id="element-170" data-mp="7924um9r1f5e">
                  {quote.author}
                </span>
                <span className="block text-sm text-gray-500" data-id="element-171" data-mp="zwpljq7wflmr">{quote.role}</span>
                <span className="inline-flex items-center gap-1 text-sm text-gray-500" data-id="element-172" data-mp="14vj3pvy4s0t9">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-173" data-mp="14xddqf7v68ik" />
                  {quote.city}
                </span>
              </span>
            </div>
            <blockquote className="text-lg leading-relaxed text-ink md:text-xl" data-id="element-174" data-mp="v4emsqowa5vs">
              “{quote.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}